import Script from "next/script"

export default function EnrollEmbed({ blok }) {
  return (
    <>
      <Script src={blok.script_url.url} 
        strategy="lazyOnload" 
        id="ps-enroll-script" data-ps-store={blok.store} />
        <div  id="ps-enroll"></div>
    </>
  )
}
